<template>
	<div class="section-reports">
		<router-view />
	</div>
</template>

<script>
	import Vue from 'vue';

	export default Vue.extend({});
</script>
